import { useContext } from 'react';
import { Grid, Paper } from '@mui/material';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import InputConfig from '../../../../../Components/InputConfig';
import CheckBoxInput from '../../../../../Components/CheckBoxInput';
import PageHeading from '../../../../../Components/PageHeading';
import useCommonStyles from '../../../../../commonStyles';

//===============

const CtaCustomFeaturesConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="CTA Custom Features Config"
				headingPath={['Dashboard', 'Framerate', 'CTA Custom Features Config']}
				description="Enables customization of CTA visual properties for video playback"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid
				container
				spacing={2}
				xs={12}
				style={{
					marginTop: '5rem',
					marginLeft: '3rem',
					width: '90%',
					display: 'flex',
					flexWrap: 'wrap',
					gap: '3rem'
				}}
			>
				<Grid item xs={3}>
					<InputConfig
						inputType="number"
						label="Cta Transparency (%)"
						keyData={keyData + '.ctaTransparency'}
						object={rawConfig}
						onChangeCheck={(val) => val >= 0 && val <= 100}
						updateObject={updateRawConfig}
					/>
				</Grid>

				<Grid item xs={3}>
					<InputConfig
						label="Cta Text Color"
						keyData={keyData + '.ctaTextColor'}
						placeholder="e.g. #000 / rgba(...)"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>

				<Grid item xs={3}>
					<InputConfig
						label="Cta Background Color"
						keyData={keyData + '.ctaBackgroundColor'}
						placeholder="e.g. #000 / rgba(...)"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>

				<Grid item xs={4} style={{ width: '26rem', maxWidth: '36rem' }}>
					<CheckBoxInput
						keyData={keyData + '.ctaOpenInSameTab'}
						label="Open Cta Url In same Tab"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default CtaCustomFeaturesConfig;
